import { TicketAttachment, TicketHistory } from '@/types/support/TicketType'
import { TicketHistoryResponse, isTicketHistoryResponse } from '@/types/support/TicketResponseType'
import { Translator } from '@/types/ApiResponseTypes'
import { parseIsoDateTime } from '@/utils/common'

class TicketHistoryResponseTranslator implements Translator<TicketHistory> {
  convert(response: any): TicketHistory {
    if (isTicketHistoryResponse(response)) {
      if (Array.isArray(response)) {
        return this.convertToTicketHistoryModel(response[0])
      } else {
        return this.convertToTicketHistoryModel(response)
      }
    }
    return {} as TicketHistory
  }
  convertToTicketHistoryModel(history: TicketHistoryResponse): TicketHistory {
    const attachments = Array<TicketAttachment>()
    for (const file of history.attachments) {
      attachments.push({
        fileName: file.fileName,
        fileType: file.fileName,
        fileDate: parseIsoDateTime(file.fileDate),
        fileUrl: file.fileUrl,
        fileId: 'fileId' in file ? file.fileId : 0,
      })
    }
    return {
      historyId: history.historyId,
      date: parseIsoDateTime(history.date),
      inputType: history.inputType,
      actionType: history.actionType,
      content: history.content,
      employee: history.employee,
      createdBy: history.createdBy,
      attachments: attachments,
    }
  }
}
export default new TicketHistoryResponseTranslator()
